(function () {
  const drawer = document.querySelector('[data-rhri-cart-drawer]');
  const itemsNode = document.querySelector('[data-rhri-cart-items]');
  const countNodes = document.querySelectorAll('[data-rhri-cart-count]');
  const subtotalNode = document.querySelector('[data-rhri-cart-subtotal]');

  function money(cents) {
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    refreshCart();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  async function cartRequest(url, options) {
    const response = await fetch(url, options);
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }

  async function refreshCart() {
    if (!itemsNode) return;
    const cart = await cartRequest('/cart.js');
    countNodes.forEach((node) => { node.textContent = cart.item_count; });
    if (subtotalNode) subtotalNode.textContent = money(cart.total_price);
    itemsNode.innerHTML = cart.items.length ? cart.items.map((item, index) => `
      <div class="rhri-cart-line" data-line="${index + 1}">
        <img src="${item.image ? item.image.replace(/(\.\w+)$/, '_160x160$1') : ''}" alt="${item.product_title}" width="80" height="80">
        <div class="rhri-cart-line__info">
          <strong>${item.product_title}</strong>
          ${item.variant_title ? `<span class="rhri-cart-line__variant">${item.variant_title}</span>` : ''}
          <div class="rhri-quantity" aria-label="Quantity for ${item.product_title}" style="margin-top:8px;">
            <button type="button" data-rhri-change="${index + 1}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
            <input value="${item.quantity}" readonly aria-label="Quantity">
            <button type="button" data-rhri-change="${index + 1}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div class="rhri-cart-line__actions">
          <span class="rhri-cart-line__price">${money(item.final_line_price)}</span>
          <button class="rhri-trash" type="button" data-rhri-remove="${index + 1}" aria-label="Remove ${item.product_title}">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2m-10 0 1 15h10l1-15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
        </div>
      </div>
    `).join('') : `
      <div class="rhri-cart-empty">
        <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
        <p>Your cart is empty.</p>
      </div>
    `;
  }

  document.addEventListener('click', async (event) => {
    const open = event.target.closest('[data-rhri-open-cart]');
    const close = event.target.closest('[data-rhri-close-cart]');
    const add = event.target.closest('[data-rhri-add-to-cart]');
    const change = event.target.closest('[data-rhri-change]');
    const remove = event.target.closest('[data-rhri-remove]');

    if (open) openDrawer();
    if (close) closeDrawer();

    if (add) {
      event.preventDefault();
      const form = add.closest('form');
      const data = form ? new FormData(form) : null;
      if (!data) return;
      await cartRequest('/cart/add.js', { method: 'POST', body: data });
      openDrawer();
    }

    if (change || remove) {
      event.preventDefault();
      const line = Number((change || remove).dataset.rhriChange || (change || remove).dataset.rhriRemove);
      const quantity = remove ? 0 : Number(change.dataset.qty);
      await cartRequest('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      refreshCart();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  refreshCart().catch(() => {});

  window.rhriCart = { open: openDrawer, refresh: refreshCart };


  /* =============================================
     REMOVE REVIEW-APP "WRITE REVIEW" WIDGETS FROM PRODUCT CARDS
     ============================================= */
  (function () {
    const WRITE_RE = /^write\s+a?\s*review$/i;

    function purge() {
      document.querySelectorAll('.rhri-product-card, .rhri-compare-card').forEach(card => {
        card.querySelectorAll('a, button, span, div, p').forEach(el => {
          if (WRITE_RE.test(el.textContent.trim())) {
            const widget = el.closest('[class*="areviews"],[class*="ar-widget"],[class*="review-badge"],[class*="judgeme"],[class*="stamped"],[class*="yotpo"],[class*="spr-badge"],[class*="loox"]') || el.parentElement;
            if (widget && widget !== card) widget.style.display = 'none';
            else el.style.display = 'none';
          }
        });
      });
    }

    purge();
    new MutationObserver(purge).observe(document.body, { childList: true, subtree: true });
  })();


  /* =============================================
     LIVE AJAX SEARCH
     ============================================= */
  (function () {
    const toggle    = document.getElementById('rhri-search-toggle');
    const drawer    = document.getElementById('rhri-search-drawer');
    const backdrop  = document.getElementById('rhri-search-backdrop');
    const input     = document.getElementById('rhri-search-input');
    const results   = document.getElementById('rhri-search-results');
    const clearBtn  = document.getElementById('rhri-search-clear');
    const closeBtn  = document.getElementById('rhri-search-close');

    if (!toggle || !drawer) return;

    let debounceTimer = null;
    let lastQuery = '';
    const MAX_RESULTS = 5;

    function openSearch() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      setTimeout(() => input && input.focus(), 280);
      document.body.style.overflow = 'hidden';
    }

    function closeSearch() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    function money(cents) {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
      return '$' + (cents / 100).toFixed(2);
    }

    function renderResults(items, query) {
      if (!items || items.length === 0) {
        results.innerHTML = `<p class="rhri-search-empty">No results for "<strong>${escapeHtml(query)}</strong>" — try a different term.</p>`;
        return;
      }

      const shown = items.slice(0, MAX_RESULTS);
      const html = shown.map(item => {
        const imgSrc = item.featured_image
          ? item.featured_image.url + '&width=140'
          : null;
        const imgHtml = imgSrc
          ? `<img class="rhri-search-result__image" src="${escapeHtml(imgSrc)}" alt="${escapeHtml(item.title)}" width="68" height="68" loading="lazy">`
          : `<div class="rhri-search-result__image--placeholder">
               <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg>
             </div>`;
        const price = item.price_min ? `<p class="rhri-search-result__price">${money(item.price_min)}</p>` : '';
        const vendor = item.vendor ? `<p class="rhri-search-result__meta">${escapeHtml(item.vendor)}</p>` : '';
        return `<a class="rhri-search-result" href="${escapeHtml(item.url)}" role="option">
          ${imgHtml}
          <div>
            <p class="rhri-search-result__title">${escapeHtml(item.title)}</p>
            ${vendor}
            ${price}
          </div>
        </a>`;
      }).join('');

      const viewAll = `<a class="rhri-search-viewall" href="/search?q=${encodeURIComponent(query)}&type=product">
        View all results for "${escapeHtml(query)}"
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
      </a>`;

      results.innerHTML = html + viewAll;
    }

    function escapeHtml(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    async function doSearch(query) {
      if (!query || query.trim().length < 2) {
        results.innerHTML = '';
        return;
      }
      query = query.trim();
      if (query === lastQuery) return;
      lastQuery = query;

      results.innerHTML = '';
      results.classList.add('rhri-search-results--loading');

      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${MAX_RESULTS + 1}&resources[options][fields]=title,product_type,variants.title,vendor`;
        const res = await fetch(url);
        if (!res.ok) throw new Error('Search failed');
        const data = await res.json();
        const items = data.resources && data.resources.results && data.resources.results.products
          ? data.resources.results.products
          : [];
        results.classList.remove('rhri-search-results--loading');
        renderResults(items, query);
      } catch (err) {
        results.classList.remove('rhri-search-results--loading');
        results.innerHTML = `<p class="rhri-search-empty">Something went wrong. <a href="/search?q=${encodeURIComponent(query)}" style="color:var(--rhri-accent)">See full results →</a></p>`;
      }
    }

    // Events
    toggle.addEventListener('click', openSearch);
    closeBtn && closeBtn.addEventListener('click', closeSearch);
    backdrop && backdrop.addEventListener('click', closeSearch);

    clearBtn && clearBtn.addEventListener('click', () => {
      input.value = '';
      input.focus();
      clearBtn.hidden = true;
      results.innerHTML = '';
      lastQuery = '';
    });

    input && input.addEventListener('input', () => {
      const q = input.value;
      clearBtn && (clearBtn.hidden = !q);
      clearTimeout(debounceTimer);
      if (!q || q.trim().length < 2) {
        results.innerHTML = '';
        lastQuery = '';
        return;
      }
      debounceTimer = setTimeout(() => doSearch(q), 280);
    });

    input && input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const q = input.value.trim();
        if (q) window.location.href = `/search?q=${encodeURIComponent(q)}&type=product`;
      }
      if (e.key === 'Escape') closeSearch();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeSearch();
    });
  })();


  /* =============================================
     PRODUCT GALLERY — THUMBNAIL SWITCHING
     ============================================= */
  (function () {
    function initGallery(gallery) {
      const thumbs  = gallery.querySelectorAll('.rhri-gallery__thumb');
      const slides  = gallery.querySelectorAll('.rhri-gallery__slide');
      const qtyBtns = document.querySelectorAll('[data-qty-change]');

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => {
          thumbs.forEach(t => t.classList.remove('is-active'));
          slides.forEach(s => s.classList.remove('is-active'));
          thumb.classList.add('is-active');
          if (slides[i]) slides[i].classList.add('is-active');
        });
      });

      // Quantity stepper
      qtyBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const input = btn.closest('.rhri-pdp-qty').querySelector('.rhri-pdp-qty__input');
          if (!input) return;
          const delta = parseInt(btn.dataset.qtyChange, 10);
          const newVal = Math.max(1, Math.min(99, parseInt(input.value, 10) + delta));
          input.value = newVal;
        });
      });
    }

    const gallery = document.querySelector('.rhri-gallery');
    if (gallery) initGallery(gallery);
  })();


  /* =============================================
     BEFORE & AFTER DRAG SLIDER
     ============================================= */
  (function () {
    function initSlider(slider) {
      const before = slider.querySelector('.rhri-ba-before');
      const handle = slider.querySelector('.rhri-ba-handle');
      let dragging = false;

      function setClip(pct) {
        pct = Math.max(2, Math.min(98, pct));
        const val = pct + '%';
        before.style.setProperty('--clip', val);
        handle.style.setProperty('--clip', val);
      }

      function getPct(clientX) {
        const rect = slider.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      // Mouse
      slider.addEventListener('mousedown', (e) => {
        dragging = true;
        slider.classList.add('is-dragging');
        setClip(getPct(e.clientX));
        e.preventDefault();
      });
      window.addEventListener('mousemove', (e) => {
        if (!dragging) return;
        setClip(getPct(e.clientX));
      });
      window.addEventListener('mouseup', () => {
        dragging = false;
        slider.classList.remove('is-dragging');
      });

      // Touch
      slider.addEventListener('touchstart', (e) => {
        dragging = true;
        slider.classList.add('is-dragging');
        setClip(getPct(e.touches[0].clientX));
      }, { passive: true });
      slider.addEventListener('touchmove', (e) => {
        if (!dragging) return;
        setClip(getPct(e.touches[0].clientX));
      }, { passive: true });
      slider.addEventListener('touchend', () => {
        dragging = false;
        slider.classList.remove('is-dragging');
      });
    }

    document.querySelectorAll('[data-ba-slider]').forEach(initSlider);
  })();


  /* =============================================
     SHOPPABLE LOOK — POINTER + LIST SYNC + ADD ALL
     ============================================= */
  (function () {
    function initLook(section) {
      const pointers  = section.querySelectorAll('.rhri-pointer');
      const badges    = section.querySelectorAll('.rhri-pointer-badge');
      const items     = section.querySelectorAll('.rhri-look-product');
      const addAllBtn = section.querySelector('.rhri-look__add-all');

      function setActive(idx) {
        pointers.forEach((p, i) => p.classList.toggle('is-active', i === idx));
        badges.forEach((b, i)   => b.classList.toggle('is-active', i === idx));
        items.forEach((it, i)   => it.classList.toggle('is-active', i === idx));
      }

      pointers.forEach((pointer, i) => {
        pointer.addEventListener('mouseenter', () => setActive(i));
        pointer.addEventListener('mouseleave', () => setActive(-1));
        pointer.addEventListener('focus',      () => setActive(i));
        pointer.addEventListener('blur',       () => setActive(-1));
      });

      items.forEach((item, i) => {
        item.addEventListener('mouseenter', () => setActive(i));
        item.addEventListener('mouseleave', () => setActive(-1));
      });

      // Badge individual add-to-cart
      section.querySelectorAll('[data-rhri-badge-add]').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.stopPropagation();
          const id = btn.dataset.rhriBadgeAdd;
          if (!id) return;
          const orig = btn.textContent;
          btn.textContent = 'Adding...';
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
            });
            if (!res.ok) throw new Error('Cart add failed');
            btn.textContent = 'Added ✓';
            setTimeout(() => { btn.textContent = orig; }, 2000);
            if (window.rhriCart) window.rhriCart.open();
          } catch {
            btn.textContent = 'Error';
            setTimeout(() => { btn.textContent = orig; }, 2000);
          }
        });
      });

      // Add ALL products to cart (one by one so a single unavailable item can't block the rest)
      if (addAllBtn) {
        addAllBtn.addEventListener('click', async () => {
          const seen = new Set();
          const variantIds = [];
          section.querySelectorAll('[data-variant]').forEach(el => {
            const id = parseInt(el.dataset.variant, 10);
            if (id > 0 && !seen.has(id)) { seen.add(id); variantIds.push(id); }
          });
          if (variantIds.length === 0) return;

          const origHTML = addAllBtn.innerHTML;
          addAllBtn.disabled = true;
          addAllBtn.textContent = 'Adding...';

          let added = 0;
          for (const id of variantIds) {
            try {
              const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id, quantity: 1 }] })
              });
              if (res.ok) added++;
              else {
                const err = await res.json().catch(() => ({}));
                console.warn('[RHRI] Could not add variant', id, err.description || err.message);
              }
            } catch (e) {
              console.warn('[RHRI] Fetch error for variant', id, e);
            }
          }

          if (added > 0) {
            addAllBtn.textContent = `✓ ${added} item${added !== 1 ? 's' : ''} added`;
            if (window.rhriCart) window.rhriCart.open();
          } else {
            addAllBtn.textContent = 'Error — try again';
          }
          setTimeout(() => { addAllBtn.innerHTML = origHTML; addAllBtn.disabled = false; }, 2800);
        });
      }
    }

    document.querySelectorAll('.rhri-look').forEach(initLook);
  })();


  /* =============================================
     CAROUSEL PREV / NEXT BUTTONS
     ============================================= */
  (function () {
    function getScrollAmount(row) {
      // Scroll by the width of one visible card (first child width + gap)
      const child = row.firstElementChild;
      if (!child) return row.clientWidth * 0.8;
      const style = window.getComputedStyle(row);
      const gap = parseFloat(style.gap || style.columnGap) || 20;
      return child.offsetWidth + gap;
    }

    function updateBtnStates(row, prevBtn, nextBtn) {
      if (!prevBtn || !nextBtn) return;
      const atStart = row.scrollLeft <= 4;
      const atEnd   = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', atEnd   ? 'true' : 'false');
    }

    document.addEventListener('click', (e) => {
      const prevBtn = e.target.closest('[data-rhri-prev]');
      const nextBtn = e.target.closest('[data-rhri-next]');
      const btn = prevBtn || nextBtn;
      if (!btn) return;

      const targetId = btn.dataset.rhriPrev || btn.dataset.rhriNext;
      const row = document.getElementById(targetId);
      if (!row) return;

      const amount = getScrollAmount(row);
      row.scrollBy({ left: prevBtn ? -amount : amount, behavior: 'smooth' });
    });

    // Wire up scroll listeners for all carousel rows
    document.querySelectorAll('.rhri-scroll-row[id]').forEach((row) => {
      const id = row.id;
      const prevBtn = document.querySelector(`[data-rhri-prev="${id}"]`);
      const nextBtn = document.querySelector(`[data-rhri-next="${id}"]`);

      updateBtnStates(row, prevBtn, nextBtn);

      row.addEventListener('scroll', () => {
        updateBtnStates(row, prevBtn, nextBtn);
      }, { passive: true });
    });
  })();


  /* =============================================
     MOBILE NAV SIDEBAR
     ============================================= */
  (function () {
    const mobileNav = document.getElementById('rhri-mobile-nav');
    const hamburger = document.querySelector('[data-rhri-mobile-toggle]');
    const closeBtn  = document.getElementById('rhri-mobile-close');
    const backdrop  = mobileNav && mobileNav.querySelector('[data-rhri-mobile-backdrop]');

    if (!mobileNav) return;

    function openNav() {
      mobileNav.classList.add('is-open');
      mobileNav.setAttribute('aria-hidden', 'false');
      hamburger && hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeNav() {
      mobileNav.classList.remove('is-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      hamburger && hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    hamburger && hamburger.addEventListener('click', openNav);
    closeBtn  && closeBtn.addEventListener('click', closeNav);
    backdrop  && backdrop.addEventListener('click', closeNav);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) closeNav();
    });

    mobileNav.querySelectorAll('[data-rhri-acc-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        const target   = document.getElementById(btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', String(!expanded));
        if (target) target.hidden = expanded;
      });
    });
  })();


  /* =============================================
     ANNOUNCEMENT BAR SLIDER
     ============================================= */
  (function () {
    const track = document.querySelector('[data-announcement-track]');
    if (!track) return;

    const items = Array.from(track.children);
    const count = items.length;
    if (count <= 1) return;

    const speed = parseInt(track.dataset.speed, 10) || 4000;
    const bar = track.closest('[data-announcement-bar]');
    const itemH = items[0].offsetHeight;

    // Clone first item so the loop resets seamlessly
    track.appendChild(items[0].cloneNode(true));

    let idx = 0;
    let timer;

    function next() {
      idx++;
      track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
      track.style.transform = `translateY(-${idx * itemH}px)`;

      if (idx === count) {
        setTimeout(() => {
          track.style.transition = 'none';
          track.style.transform = 'translateY(0)';
          idx = 0;
        }, 520);
      }
    }

    function start() { timer = setInterval(next, speed); }
    function stop()  { clearInterval(timer); }

    start();
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
  })();
})();
